import { useQuery } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'
import type { components } from '@/lib/generated/api-types'

export type AccountPolicyResponse =
  components['schemas']['AccountPolicyResponse']
export type AccountPolicyListResponse =
  components['schemas']['AccountPolicyListResponse']

// List all account policies
export function usePolicies() {
  return useQuery({
    queryKey: queryKeys.policies.all,
    queryFn: async () => {
      const { data, error } = await client.GET('/api/v1/policies')
      if (error) throw error
      return data
    },
    staleTime: 30 * 1000,
  })
}

// List valid action names
export function usePolicyActions() {
  return useQuery({
    queryKey: queryKeys.policies.actions,
    queryFn: async () => {
      const { data, error } = await client.GET('/api/v1/policies/actions')
      if (error) throw error
      return data
    },
    staleTime: 10 * 60 * 1000, // Actions rarely change
  })
}
